export const recipeSelected = recipe => ({
  type: 'Recipe Selected',
  data: {
    recipe,
  },
});

export const recipeUnselected = recipe => ({
  type: 'Recipe Unselected',
  data: {
    recipe,
  },
});

export const recipesShown = (
  selected_recipes,
  unselected_recipes,
  excluded_recipes,
) => ({
  type: 'Recipes Shown',
  data: {
    selected_recipes,
    unselected_recipes,
    excluded_recipes,
  },
});

export const userContinuesToCheckoutEvent = selectedRecipes => ({
  type: 'User continues from fresh recipes',
  data: {
    recipes_count: selectedRecipes.length,
    recipes_selected: selectedRecipes,
  },
});

export const userViewFreshRecipeScreen = numAvailableRecipes => ({
  type: 'User views fresh recipes page',
  data: {
    available_recipes: numAvailableRecipes,
  },
});

export const userExpandsFreshRecipeDetails = recipe => ({
  type: 'User expands fresh recipe details',
  data: {
    recipe,
  },
});
